import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
  Row,
  Col,
} from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import { toast } from "react-toastify";

export const EditUserModal = ({ isOpen, toggle, user }) => {
  const { patchData,invalidateQuery } = useDataFetch();
  const { mutateAsync: updateUser, isPending } = patchData(`/users/update/userByDash`);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      multyhealth_code: user?.multyhealth_code || "",
      name: user?.name || "",
      document: user?.document || "",
      email: user?.email || "",
      cellphone: user?.cellphone || "",
      dateOfBirth: user?.dateOfBirth || "",
    },
  });

  const onSubmit = async (formData) => {
    // Quitamos el multyhealth_code del payload
    const { multyhealth_code, ...data } = formData;

    try {
      await updateUser({ id: user.id, ...data });
      invalidateQuery(["users"]);
      toast.success("Usuario actualizado correctamente");
      toggle();
    } catch (error) {
      toast.error("Error al actualizar usuario");
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Editar Usuario</ModalHeader>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <ModalBody>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Código</Label>
                <Controller
                  name="multyhealth_code"
                  control={control}
                  render={({ field }) => (
                    <Input {...field} type="text" readOnly disabled />
                  )}
                />
              </FormGroup>
            </Col>

            <Col md="6">
              <FormGroup>
                <Label>Documento</Label>
                <Controller
                  name="document"
                  control={control}
                  rules={{ required: "El documento es obligatorio" }}
                  render={({ field }) => <Input {...field} type="text" />}
                />
                {errors.document && (
                  <span className="text-danger small">
                    {errors.document.message}
                  </span>
                )}
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Nombre</Label>
                <Controller
                  name="name"
                  control={control}
                  rules={{ required: "El nombre es obligatorio" }}
                  render={({ field }) => <Input {...field} type="text" />}
                />
                {errors.name && (
                  <span className="text-danger small">
                    {errors.name.message}
                  </span>
                )}
              </FormGroup>
            </Col>

            <Col md="6">
              <FormGroup>
                <Label>Correo</Label>
                <Controller
                  name="email"
                  control={control}
                  rules={{ required: "El correo es obligatorio" }}
                  render={({ field }) => <Input {...field} type="email" />}
                />
                {errors.email && (
                  <span className="text-danger small">
                    {errors.email.message}
                  </span>
                )}
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Teléfono</Label>
                <Controller
                  name="cellphone"
                  control={control}
                  render={({ field }) => <Input {...field} type="text" />}
                />
              </FormGroup>
            </Col>

            <Col md="6">
              <FormGroup>
                <Label>Fecha de nacimiento</Label>
                <Controller
                  name="dateOfBirth"
                  control={control}
                  render={({ field }) => <Input {...field} type="date" />}
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancelar
          </Button>
          <Button color="primary" type="submit" disabled={isPending}>
            {isPending ? <Spinner size="sm" /> : "Guardar Cambios"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};
